// FullScreenLoader.tsx
import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";

type SimpleLoadingProps = {
  open?: boolean;
  message?: string;
};

export const FullSizeLoading: React.FC<SimpleLoadingProps> = ({ open = true, message }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <CircularProgress color="inherit" />
      {message && (
        <Typography variant="body1" px={2} sx={{ color: "inherit" }}>
          {message}
        </Typography>
      )}
    </Backdrop>
  );
};


// コンテンツ領域用の読み込み表示。背景を暗転させず、まだ読み込まれていないUI部分に
// そのまま置いて使う(ページのヘッダーやタイトルは通常どおり表示したままにできる)。
export const ContentLoading: React.FC<SimpleLoadingProps & { minHeight?: number | string }> = ({ message = "読み込み中...", minHeight = 320 }) => {
  return (
    <Stack alignItems="center" justifyContent="center" gap={1.5} sx={{ minHeight, py: 6, color: "text.secondary" }}>
      <CircularProgress size={40} />
      {message && (
        <Typography variant="body2" sx={{ color: "inherit" }}>
          {message}
        </Typography>
      )}
    </Stack>
  );
};
